import { z } from 'zod';
import { type TranslationKey } from '@/i18n/translation-key.tsx';

export const updateFlowSlotBreakSchemaFactory = (t: (key: TranslationKey) => string) => {
  return z.object({
    title: z.string().min(2, t('flows.detail.slotList.detail.updateBreak.validation.titleMinLength')),
  });
};
